import BaseModel from "./baseModel";

export default class CocModel extends BaseModel {
  static endPoint = "coc-delete-requests/";
}
